import { TabContext, TabList, TabPanel } from "@mui/lab"
import { Badge, Box, IconButton, styled, Tab, Typography, useTheme, Divider } from "@mui/material"
import AppAvatar from "components/avatars/AppAvatar"
import FlexBox from "components/flexbox/FlexBox"
import { H6, Paragraph, Tiny } from "components/Typography"
import NotificationsIcon from "icons/NotificationsIcon"
import { Fragment, useRef, useState, useContext, useEffect } from "react"
import PopoverLayout from "./PopoverLayout" // dummy  data
import { useNavigate } from "react-router-dom"

import { NotificationContext } from "contexts/NotificationContext"
import { UserContext } from "contexts/UserContext"
import moment from "moment"

import { replacePath } from "utils/replacePath"

const StyledIconButton = styled(IconButton)(({ theme }) => ({
	"&:hover": {
		backgroundColor: theme.palette.action.hover
	}
}))
const StyledTab = styled(Tab)(() => ({
	width: "50%",
	marginLeft: 0,
	marginRight: 0
}))

const NotificationsPopover = () => {
	const { notifLimits, getNotifLimit, updateReceived, getBadge, badge } = useContext(NotificationContext)
	const { dataUser, getDataUser } = useContext(UserContext)

	const anchorRef = useRef(null)
	const [open, setOpen] = useState(false)
	const [tabValue, setTabValue] = useState("1")

	const handleTabChange = (_, value) => {
		setTabValue(value)
	}

	const handleClickBadge = async () => {
		try {
			let res = await getDataUser()
			if (res?.id) {
				await updateReceived({ userid: res?.id })
				await fetchData()
			}

			setOpen(true)
		} catch (err) {
			console.log(err)
		}
	}

	const fetchData = async () => {
		try {
			let res = await getDataUser()
			let params = { userid: res?.id }
			if (res?.id) {
				await getNotifLimit({ params })
				await getBadge({ params })
			}
		} catch (err) {
			// alert(err)
			console.log("err get notif", err)
		}
	}

	useEffect(() => {
		fetchData()
	}, [])

	const unreadMsg = notifLimits.filter((item) => !item.received)

	// console.log(notifications)

	return (
		<Fragment>
			<StyledIconButton
				ref={anchorRef}
				onClick={handleClickBadge}
			>
				<Badge
					color="error"
					badgeContent={badge}
				>
					<NotificationsIcon
						sx={{
							color: "text.disabled"
						}}
					/>
				</Badge>
			</StyledIconButton>

			<PopoverLayout
				title="Notifications"
				popoverOpen={open}
				anchorRef={anchorRef}
				popoverClose={() => setOpen(false)}
			>
				<TabContext value={tabValue}>
					{notifLimits.length === 0 ? (
						<Paragraph
							fontWeight="500"
							textAlign="center"
							p={2}
						>
							There are no notifications
						</Paragraph>
					) : (
						<TabPanel value="1">
							{notifLimits.map((msg) => (
								<ListItem
									msg={msg}
									key={msg._id}
								/>
							))}
						</TabPanel>
					)}
				</TabContext>
			</PopoverLayout>
		</Fragment>
	)
} // ListItem component props

function ListItem({ msg }) {
	const { getNotifLimit, putNotif } = useContext(NotificationContext)
	const theme = useTheme()
	const colorbg = theme.palette.mode === "light" ? "secondary.light" : "divider"
	const navigate = useNavigate()

	const handleReadNotif = async () => {
		if (!msg.read) {
			try {
				await putNotif(msg._id, { read: true })
				await getNotifLimit({ params: { userid: msg.userid } })
				navigate(`${replacePath(msg.url)}`)
			} catch (err) {
				console.log("notif problem", err)
			}
		} else {
			navigate(`${replacePath(msg.url)}`, { replace: true })
		}
	}
	return (
		<FlexBox
			onClick={handleReadNotif}
			p={2}
			// alignItems="center"
			sx={{
				borderBottom: 1,
				cursor: "pointer",
				borderColor: "divider",
				backgroundColor: !msg.read ? colorbg : "transparent",
				"&:hover": {
					backgroundColor: colorbg
				}
			}}
		>
			<FlexBox alignItems="center">
				<Box
					sx={{
						width: 8,
						height: 8,
						marginRight: 2,
						borderRadius: "50%",
						backgroundColor: msg?.read ? "primary.main" : "text.disabled"
					}}
				/>
				<AppAvatar
					src={msg?.img}
					sx={{
						width: 35,
						height: 35
					}}
				/>
			</FlexBox>

			<Box ml={2}>
				<Box>
					<H6>{msg.title}</H6>
					<Tiny
						display="block"
						fontWeight={500}
						color="text.disabled"
					>
						{msg?.body + ". "}
					</Tiny>
					{/* <Tiny
						display="block"
						fontWeight={500}
						color="text.disabled"
					>
						{msg?.url}
					</Tiny> */}
				</Box>
			</Box>
			<Box>
				<Tiny
					display="block"
					fontWeight={400}
					color="text.disabled"
				>
					{moment(msg?.createdAt).format("DD MMM YY HH:mm")}
				</Tiny>
			</Box>
			{/* <NotificationsIcon sx={{ color: "primary.main" }} /> */}
		</FlexBox>
	)
}

export default NotificationsPopover
